import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { platformFeatures } from 'shared/constants'

const getMessage = (type, t) => {
  switch (type) {
    case platformFeatures.model_subscription:
      return (
        <>
          {t('Subscription licensing is not offered in your current plan.')}
          &nbsp;
          {t('Upgrade to unlock subscription licensing.')}
        </>
      )
    case platformFeatures.model_consumption:
      return (
        <>
          {t('Consumption licensing is not offered in your current plan.')}
          &nbsp;
          {t('Contact sales to support consumption licensing.')}
        </>
      )
    default:
      return (
        <>
          {t('This license model is not available in your current plan.')}
          &nbsp;
          {t('To compare different plan types click')}
          <a
            style={{ marginLeft: '3px' }}
            href='https://licensespring.com/pricing'
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('here')}
          </a>
        </>
      )
  }
}

const LicenseNotAvailableMessage = ({ type }) => {
  const { t } = useTranslation()
  return <div className='feature-unavailable-tooltip'>{getMessage(type, t)}</div>
};

LicenseNotAvailableMessage.propTypes = {
  type: PropTypes.string.isRequired,
};

export default LicenseNotAvailableMessage;
